import { Component, OnInit } from '@angular/core';
import { AppService } from './app.service';
import { INITIAL_MODAL_STATE, Modal } from './shared/models/dialog.model';
import { AuthService } from './shared/services/auth.service';
import { SharedStateService } from './shared/services/shared-state.service';
import { StorageService } from './shared/services/storage.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'HILViewer';
  showSessionTimeOutModal: boolean = false;
  public sessionTimeOutModel: Modal = INITIAL_MODAL_STATE;
  public sessionTimeOutLocalize: any;
  uploadError: any;
  showUploadErrorModal: boolean;
  showInfoPopUp: boolean;
  sessionUploadErrorLocalize: any;
  userActions: any;
  idleTime: number;
  auditAction: any;

  constructor(
    private appService: AppService,
    private translate: TranslateService,
    private bnIdle: BnNgIdleService,
    private router: Router,
    private authService: AuthService,
    private sharedState: SharedStateService,
    private storageService: StorageService,
    public dialog: MatDialog
  ) {
    translate.setDefaultLang('en');
    this.translate.get(['sessionTimeOutModal']).subscribe((data) => {
      this.sessionTimeOutLocalize = data.sessionTimeOutModal;
    });

    this.translate.get(['uploadErrorModel']).subscribe((data) => {
      this.sessionUploadErrorLocalize = data.uploadErrorModel;
    });
    this.translate.get(['UserActions']).subscribe((data) => {
      this.userActions = data;
      this.sharedState.userActionDetails(this.userActions);
    });
    this.ssmInfo();
    //get the Session Idle Timeout Value by subscribing the latest Observable
    this.sharedState.ssmIdleTimeData$.subscribe(response => {
      if (response) {
        this.idleTime = +response;
        if (this.idleTime != 0) {
          this.checkInactivity();
        }
      }
    })
    this.sharedState.timeOutCallbacsubject.subscribe(response =>{
      this.timeOutSignOut(response.res)
    })
  }

  ngOnInit(): void {
    //To get user actions from json file
    this.sharedState.userActionStateData$.subscribe((response) => {
      this.auditAction = response;
    });
  }

  timeOutSignOut(res){
    localStorage.setItem('checkInactivity', 'false');
    if (res && (!this.router.url.includes('/signin')
      && !this.router.url.includes('/signup') && !this.router.url.includes('/logout'))) {
      localStorage.setItem('checkInactivity', 'true');
      if (!this.router.url.includes('/patientviewer')) {
        /* Session timeout dialog */
        this.showSessionTimeOutModal = true;
        this.sessionTimeOutModel = {
          display: 'block',
          header: this.sessionTimeOutLocalize.header,
          content: this.sessionTimeOutLocalize.content,
          okButton: this.sessionTimeOutLocalize.okBtn,
          cancelButton: '',
          submitFunction: () => {},
          closeFunction: () => {
            this.closeSessionTimeOutDialog();
          }
        };
        this.sharedState.idleTimeout('TIMEOUT');
      }

      this.authService.auditLogOutActivity(
        this.auditAction.UserActions.timedOutLogOut
      );
      this.authService.signOut();
    }
  }
  //fetch SSM Parameters for Session Idle Time
  public async ssmInfo(): Promise<void>{
    if (localStorage.getItem('clpSession') != null) {
      let ssmIdleTime = await this.authService.getSSMValue(environment.ssmParams.IDLETIME);
      this.sharedState.ssmIdleTimeVal(ssmIdleTime);
    }
  }
  // below function will watch the application idle time, after 15 min it will clear the sesstion and redirect to login page
  public checkInactivity() {
    localStorage.setItem('checkInactivity', 'false');
    this.bnIdle.startWatching(this.idleTime).subscribe((res) => {
      localStorage.setItem('checkInactivity', 'true');
      if(this.sharedState._isImageProcessedNew$.getValue() || this.sharedState._originalMaskBlobNew$.getValue() || this.sharedState._updatedMaskBlobNew$.getValue()){
        this.sharedState._isImageProcessedNew$.next(undefined);
        this.sharedState._originalMaskBlobNew$.next(undefined);
        this.sharedState._updatedMaskBlobNew$.next(undefined);
        this.sharedState.timeOutsubject.next({idleTime : this.idleTime, res : res });
      } else {
        this.sharedState.timeOutCallbacsubject.next({res : res});
      }
    })
  }

  public closeSessionTimeOutDialog(): void {
    this.showSessionTimeOutModal = false;
    this.sessionTimeOutModel = INITIAL_MODAL_STATE;
    this.sharedState.idleTimeoutUnsubscribe();
    let url = new URL(environment.cloudFrontCLPSignOutUrl);
    if (localStorage.getItem('checkInactivity') === 'true') {
      url.searchParams.set('inactive', 'true');
    } else {
      url.searchParams.set('inactive', 'false');
    }
    window.open(url.toString(), "_self");
  }

}
